/* eslint-disable css-modules/no-undef-class, css-modules/no-unused-class */
import { FC, useCallback, useRef, useState } from 'react';
import { NotificationsProps } from './notificationsTypes';
import EmptyNotification from '../notification/emptyNotification';
import Notification from '../notification/notification';
import './notifications.scss';

const Notifications: FC<NotificationsProps> = (props: NotificationsProps) => {
    const { notifications, loadMore, refFunction, isEmpty } = props;
    const [dismissedId] = useState<string>('');

    const observer = useRef<IntersectionObserver | null>(null);
    const lastNotificationElementRef = useCallback(
        node => {
            if (observer.current) observer.current.disconnect();
            observer.current = new IntersectionObserver(entries => {
                if (entries[0].isIntersecting) {
                    loadMore();
                }
            });
            if (node) observer.current.observe(node);
        },
        [loadMore]
    );

    return (
        <div className="notifications-wrapper">
            <div ref={refFunction}>
                {!isEmpty ? (
                    notifications.map((notification, i) => (
                        <Notification
                            top={i * 6.5}
                            className={notification.id === dismissedId ? 'dismiss-animation' : undefined}
                            key={notification.id}
                            sentDate={notification.date}
                            content={notification.content}
                            refFunction={i + 1 === notifications.length ? lastNotificationElementRef : undefined}
                            title={'Title'}
                        />
                    ))
                ) : (
                    <EmptyNotification />
                )}
            </div>
        </div>
    );
};

export default Notifications;
